import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { ConfigurationService } from "src/app/configurations/configurationService";
import { jsPDF } from "jspdf";
import { RobotoFont } from "src/app/inventory/sales-order/utils/vfs";
import { IDynamicObject } from "../inventory/sales-order/models/sales-receipt.model";
import { DatePipe } from "@angular/common";
import { ListService } from "../configurations/inventory/custom/list/list.service";
import { CustomAttributeFieldType } from "../inventory/sales-order/constants/constants";
import { AccountsTransactionType } from "../finance/constants/constants";
import { SalesOrderService } from "../inventory/sales-order/sales-order.service";
import { ModuleName } from "../modules/shared/components/receive-payments/constants/constants";

@Component({
    selector: "app-sales-receipt-pdf",

    templateUrl: "./sales-receipt-pdf.component.html",
    styleUrl: "./sales-receipt-pdf.component.scss",
})
export class SalesReceiptPdfComponent {
    @Input() fractionDigits: number = 2;
    @Input() qtyDecimal: number = 2;
    @Input() salesReceiptsByIdList;
    @Input() salesReceiptsTemplate;
    @Input() estimatesCols2;
    @Input() receivedPaymentId;
    @Input() channelName;
    @Input() soChannel;
    @Input() selectedRowData;
    @Input() companyInfo;
    @Output() getAccounId = new EventEmitter<any>();
    moduleName = ModuleName;

    accountinfo;
    rpoNumber;
    savedBill;
    ordersVendorPhoneNew = "";
    ordersVendorAddr = "";
    ordersVendorCity = "";
    ordersVendorState = "";
    ordersVendorCountry = "";
    ordersVendorZipcode = "";
    ordersVendorContactNew = "";
    allModules: any[] = [];
    allCustomFields: any[] = [];
    customFieldData: any[] = [];
    customAtributes   = {
        misc_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
        labels_misc: [],
    };
    fieldTypes = CustomAttributeFieldType;
    // barcode properties
    elementType = "img";
    format = "CODE128";
    lineColor = "#000000";
    width = 1;
    height = 20;
    displayValue = true;
    fontOptions = "";
    font = "monospace";
    textAlign = "center";
    textPosition = "bottom";
    textMargin = 2;
    fontSize = 10;
    background = "#ffffff";
    margin = 10;
    marginTop = 10;
    marginBottom = 10;
    marginLeft = 0;
    marginRight = 10;
    InvoiceTB;
    invoicingDetails;

    constructor(
        public app: AppMainComponent,
        private service: ConfigurationService,
        public datepipe: DatePipe,
        private customfieldService: ListService,
        private salesOrderService: SalesOrderService,
    ) {}

    ngOnChanges(changes: SimpleChange): void {
        this.estimatesCols2 = this.estimatesCols2?.filter((ele) => ele.checked);
        if (changes?.["salesReceiptsByIdList"]?.currentValue || changes?.["estimatesCols2"]?.currentValue) {
            this.accountinfo = this.generateDynamicObject(this.estimatesCols2, this.salesReceiptsByIdList);
            this.loadCustomFields();
            this.rpoNumber = this.selectedRowData?.number;
        }
        if (changes?.["receivedPaymentId"]?.currentValue) {
            this.detailsView();
        }
    }

    detailsView() {
        this.salesOrderService.getReceivedPaymentsById(this.receivedPaymentId).subscribe((resp) => {
            this.invoicingDetails = resp;
            this.getAccounId.emit(this.invoicingDetails?.accountId);
            this.InvoiceTB = this.invoicingDetails?.receivedPaymentDetail?.map((r) => {
                const obj = {
                    ...r,
                    invoiceId: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnId : r.invoiceId,
                    invoiceNo: r?.transactionType == AccountsTransactionType.JournalEntry ? r.txnNumber : this.channelName === this.soChannel?.SALES_ORDER ? r?.salesOrderNumber : r?.invoiceNumber,
                    invoiceAmount: r.invoiceAmount ?? 0,
                    exchangeRate: r.invoice?.exchangeRate,
                    currencyCode: r.invoice?.currencyCode,
                    // amountDue: r.amountDue ?? 0,
                    // actualDueAmount: r.amountDue ?? 0,
                    due: r.amountDue ?? 0,
                    credit: r.appliedCredit ?? 0,
                    amountApplied: r.invoiceReceivedAmount ?? 0,
                    contactId: "",
                    isCreditApplied: r.appliedCredit && r.appliedCredit > 0,
                    isReceivedPaymentApplied: true,
                    dueDate: r.dueDate ? this.app._showDateTimeWithZone(r.dueDate) : "",
                    netDueAmount: r.amountDue ?? 0,
                    actualDueAmount: r?.invoiceReceivedAmount + r?.amountDue + r?.appliedCredit,
                    // amountDue: r?.invoiceReceivedAmount + r?.amountDue + r?.appliedCredit - r?.invoiceReceivedAmount,
                };
                // this.amountTotal += Number(obj.invoiceAmount);
                // this.amountDueTotal += Number(obj.amountDue);
                // this.amountAppliedTotal += Number(obj.amountApplied);
                // this.writeOffAmountTotal += Number(obj.writeOffAmount);
                return obj;
            });
        });
    }
    generateDynamicObject(columns, salesReceiptsByIdList: any[]): IDynamicObject[] {
        if (salesReceiptsByIdList.length === 0) {
            return [];
        }
        const firstItem = salesReceiptsByIdList[0];
        return columns
            .filter((col) => col?.show)
            .map((col) => ({
                header: col?.header,
                datatype: col?.datatype,
                value: firstItem[col?.field],
                checked: col?.show,
            }));
    }
    generatePrint() {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");

        let html = document.getElementById("salesReceiptPreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="565"');
        let pdfFileName = `SalesReceipt_${this.rpoNumber}`;
        pdf.setProperties({ title: pdfFileName + ".pdf" });
        pdf.html(html, {
            callback: function (pdf) {
                const dataUri = pdf.output("datauristring");
                const newTab = window.open();
                newTab.document.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
                newTab.document.title = pdfFileName + ".pdf";
            },
            margin: [10, 15],
        });
        return pdf;
    }

    getPDF() {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");

        let html = document.getElementById("salesReceiptPreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        pdf.html(html, {
            margin: [40, 20],
        });
        return pdf;
    }
    async loadCustomFields() {
        this.allModules = this.app.preLoadedObjects;
        const obj = this.allModules.filter((obj) => obj.name == "Orders")[0];
        this.customfieldService.getAllCustomFields(obj.id).then((response) => {
            this.customFieldData = [];
            this.allCustomFields = [];
            const fields = response?.filter((el) => el.section?.typeName == "Sales Receipt");

            if (fields && fields.length > 0) {
                for (let l of fields) {
                    let eachRecord = {
                        id: Number(l.id + ""),
                        name: l.name,
                        module: this.allModules.find((el) => el.id == l.objectId)?.name,
                        formControl: l.formControl,
                        formControlId: l.formControlId,
                        isRequired: l.isRequired,
                        statusId: l.statusId,
                        statusName: l.status.name,
                        section: l.section,
                        configurationId: l.configurationId,
                        isEdit: l.isEdit,
                        isDelete: l.isDelete,
                        pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues,
                    };
                    this.customFieldData.push(eachRecord);
                }
            }
            this.allCustomFields = this.customFieldData;
            this.customAtributes.misc_item = this.allCustomFields.filter((el) => el.section?.code == "labels_misc");
            this.customAtributes.message_item = this.allCustomFields.filter((el) => el.section?.code == "labels_message");
            this.customAtributes.other1_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other1");
            this.customAtributes.other2_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other2");
            this.customAtributes.other3_item = this.allCustomFields.filter((el) => el.section?.code == "labels_salesreceipt_other3");
            this.setCustomFieldsData();
        });
    }

    setCustomFieldsData() {
        Object.keys(this.customAtributes).forEach((key) => {
            const dataArr = this.customAtributes[key];
            if (Array.isArray(dataArr) && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const sectionCode = element.section?.code;
                    const templateSection = this.salesReceiptsTemplate?.[sectionCode];
                    const matchedItem = templateSection?.find((el: any) => el.id === element?.id);
                    const isChecked = matchedItem?.isChecked ?? false;

                    element.isChecked = isChecked;
                    const filteredCustom = this.salesReceiptsByIdList[0]?.CustomAttributes?.find((c: any) => c.customAttributeId === element.id);
                    const controlType = filteredCustom?.customAttribute?.formControl?.name;

                    switch (controlType) {
                        case "InputBox":
                            element.value = filteredCustom.value;
                            break;

                        case "Decimal":
                        case "Number":
                            element.value = filteredCustom.value;
                            break;

                        case "DatePicker":
                            element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                            break;

                        case "FileUpload":
                        case "Picture":
                            element.customUploadedFiles = [...(filteredCustom?.customeAttachement ?? [])];
                            break;

                        case "Rating":
                            element.value = filteredCustom.ratingId;
                            break;

                        case "ToggleButton":
                            element.value = filteredCustom.toggle;
                            break;

                        case "DropDownList":
                            element.value = filteredCustom.values.name;
                            break;

                        case "RadioButton":
                            element.value = filteredCustom.values?.name;
                            break;

                        case "CheckBox":
                        case "MultipleDropDownList":
                            element.value = filteredCustom.multipleValues?.map((el: any) => el?.name) ?? [];
                            break;

                        default:
                            element.value = null;
                            break;
                    }
                });
            }
        });

        // Remove unchecked elements
        Object.keys(this.customAtributes).forEach((key) => {
            if (Array.isArray(this.customAtributes[key])) {
                this.customAtributes[key] = this.customAtributes[key].filter((item) => item.isChecked);
            }
        });
    }
}
